import { render, staticRenderFns } from "./TripForm.vue?vue&type=template&id=00bbd495&"
import script from "./TripForm.vue?vue&type=script&lang=js&"
export * from "./TripForm.vue?vue&type=script&lang=js&"
import style0 from "./TripForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports